// extracted by mini-css-extract-plugin
export default {"gur_wrapper":"Wrapper_gur_wrapper__j0X9o"};